import { useRoutes } from 'react-router-dom';
import { Company, Landing, ProductsServices } from 'features/misc';
import { publicRoutes } from './public';

export const AppRoutes = () => {
  const commonRoutes = [
    { path: '/', element: <Landing /> },
    { path: '/company', element: <Company /> },
    { path: '/products-and-services', element: <ProductsServices /> },
  ];

  const routes = publicRoutes;

  const element = useRoutes([...routes, ...commonRoutes]);

  return <>{element}</>;
};
